// Main exports for programmatic usage
export { kickstartCommand } from './commands/kickstart';
export type { PackageInfo } from './types'; 
export {addCommand} from './commands/add';
